/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_No_ExcerptInputs */

const cs_blog_no_excerpt = /** @type {(inputs: Blog_No_ExcerptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím bez perexu.`)
};

const en_blog_no_excerpt = /** @type {(inputs: Blog_No_ExcerptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No excerpt yet.`)
};

/**
* | output |
* | --- |
* | "No excerpt yet." |
*
* @param {Blog_No_ExcerptInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_no_excerpt = /** @type {((inputs?: Blog_No_ExcerptInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_No_ExcerptInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_no_excerpt(inputs)
	return cs_blog_no_excerpt(inputs)
});